import { render, staticRenderFns } from "./Precalculations.vue?vue&type=template&id=066f0629&scoped=true"
import script from "./Precalculations.vue?vue&type=script&lang=ts"
export * from "./Precalculations.vue?vue&type=script&lang=ts"
import style0 from "./Precalculations.vue?vue&type=style&index=0&id=066f0629&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f0629",
  null
  
)

export default component.exports